export const textareaFrame = {
    title: {
        collapse: "Réduire ce champ",
        expand: "Agrandir ce champ lors de la saisie"
    },
    label: {
        collapse: "Réduire",
        expand: "Agrandir"
    }
}